/**
 * Sidebar notice lifetimes, keyed by substring of the failure reason.
 * A reason absent from this table is a real verification failure and stays up
 * until dismissed; `0` means never shown.
 */
const NOTICE_TTL_MS = {
  user_link_display_timeout: 0,
  user_link_start_timeout: 60000,
  user_cancelled: 60000,
};

const noticeTtlMs = (reason) => {
  if (!reason) return null;
  const match = Object.keys(NOTICE_TTL_MS).find((r) => reason.includes(r));
  return match === undefined ? null : NOTICE_TTL_MS[match];
};

const createdAtMs = (failureId) => {
  const [prefix] = String(failureId ?? '').split('_');
  return /^\d+$/.test(prefix) ? Number(prefix) : null;
};

export function visibleFailures(failures, dismissedFailureIds, nowMs) {
  if (!failures?.length) return [];
  return failures.filter((failure) => {
    if (dismissedFailureIds?.includes(failure.failure_id)) return false;
    const ttl = noticeTtlMs(failure.reason);
    if (ttl === null) return true;
    const created = createdAtMs(failure.failure_id);
    if (created === null) return true;
    return nowMs - created < ttl;
  });
}
